import { getCurrentDateTime } from '../utils/unils.js';

let dataBaseVer = 1; // 版本
const dataBaseName = 'MIRROR_TRACK_V2'; // db名
const dataBaseStore = 'log'; // store名
const dataBaseKeyPath = 'key'; // 主key
const dataBaseLimit = 5000; // 数据条数限制
const indexDbHandler = {
    // 创建数据库
    createIndexedDB() {
        if (!window.indexedDB)
            return;
        return new Promise((resolve, reject) => {
            const indexed = indexedDB.open(dataBaseName, dataBaseVer);
            // 第一次执行，因为没有版本，所以会触发onupgradeneeded事件，此时新建store并追加主key
            indexed.onupgradeneeded = (event) => {
                const db = event.target.result;
                if (!db.objectStoreNames.contains(dataBaseStore)) {
                    db.createObjectStore(dataBaseStore, {
                        keyPath: dataBaseKeyPath
                    });
                }
            };
            indexed.onsuccess = (event) => {
                const request = event === null || event === void 0 ? void 0 : event.target;
                const db = request.result;
                db.close();
                resolve();
            };
            // 创建失败
            indexed.onerror = () => {
                console.log('Indexed Start Error');
                reject();
            };
        });
    },
    // 添加数据
    add(log) {
        if (!window.indexedDB)
            return;
        const time = getCurrentDateTime();
        const random = Math.ceil(Math.random() * 999);
        const timeStamp = time + '_' + random + 'Z';
        const indexed = indexedDB.open(dataBaseName, dataBaseVer);
        // 每次添加的时候 检查是否存在,不存在添加key
        indexed.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(dataBaseStore)) {
                db.createObjectStore(dataBaseStore, {
                    keyPath: dataBaseKeyPath
                });
            }
        };
        indexed.onsuccess = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(dataBaseStore)) {
                return;
            }
            const trans = db.transaction(dataBaseStore, 'readwrite');
            const store = trans.objectStore(dataBaseStore);
            const count = store.count();
            // 计算记录的数量，添加前先检查是否超过限制
            count.onsuccess = () => {
                // 以主键log为key，把时间戳和log作为value，插入数据库
                store.put({ [dataBaseKeyPath]: timeStamp, log: log });
                // 没超过就添加
                if (Number(count.result) <= dataBaseLimit)
                    return;
                // 超过就删除最老的一条
                store.openCursor().onsuccess = (event) => {
                    const cursor = event.target.result;
                    if (cursor) {
                        cursor.delete();
                    }
                };
            };
            // 计算记录的数量失败
            count.onerror = () => {
                console.log('mirror indexDb count error');
            };
            db.close();
        };
        // db打开失败
        indexed.onerror = () => {
            console.log('add Indexed Open Error');
        };
    },
    // 获取所有数据,默认需要上传返回blob,不需要上传返回数组
    getAll(isUpload = true) {
        if (!window.indexedDB)
            return;
        return new Promise((resolve, reject) => {
            let tmp = []; // 打开db
            const indexed = indexedDB.open(dataBaseName);
            indexed.onsuccess = (event) => {
                const db = event.target.result;
                if (!db.objectStoreNames.contains(dataBaseStore)) {
                    reject(`the store log not exists in the ${dataBaseName} dataBase`);
                    return;
                }
                const trans = db.transaction(dataBaseStore, 'readonly');
                const store = trans.objectStore(dataBaseStore); // 遍历数据
                if (!isUpload) {
                    const request = store.getAll();
                    request.onsuccess = function (event) {
                        const resultLog = event.target.result;
                        resolve(resultLog);
                        return;
                    };
                }
                else {
                    store.openCursor().onsuccess = (event) => {
                        var _a, _b;
                        // 如果遍历项有数据就放入tmp，然后继续
                        const cursor = event.target.result;
                        if (cursor) {
                            const str = `${(_a = cursor.value) === null || _a === void 0 ? void 0 : _a.key}-${(_b = cursor.value) === null || _b === void 0 ? void 0 : _b.log}`;
                            tmp.push(str);
                            tmp.push('\r\n');
                            cursor.continue();
                        }
                        else {
                            if (tmp.length === 0) {
                                reject('No data in the store');
                            }
                            else {
                                const blob = new Blob(tmp, {
                                    type: 'text/plain;charset=utf-8'
                                });
                                resolve(blob);
                            }
                        }
                    }; // 遍历数据失败
                    store.openCursor().onerror = () => {
                        reject('OpenCursor Error');
                    };
                }
                db.close();
            }; // db打开失败
            indexed.onerror = () => {
                reject('Indexed Open Error');
            };
        });
    },
    // 删除store
    clearStore(dbName = dataBaseName, storeName = dataBaseStore) {
        if (!window.indexedDB)
            return;
        const indexed = indexedDB.open(dbName);
        indexed.onsuccess = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(storeName))
                return;
            const transaction = db.transaction(storeName, 'readwrite');
            const objectStore = transaction.objectStore(storeName);
            objectStore.clear().onsuccess = function (event) { };
            db.close();
        };
        indexed.onerror = function (event) {
            console.log('Error opening db', event.target.error);
        };
    },
    // 删除数据库
    deleteIndexedDB(dbName = dataBaseName) {
        if (!window.indexedDB)
            return;
        const indexed = indexedDB.deleteDatabase(dbName);
        // 删除成功
        indexed.onsuccess = () => { };
        // 删除失败
        indexed.onerror = () => {
            console.log('Delete Error');
        };
    }
};

export { indexDbHandler };
